module.exports = __webpack_public_path__ + "static/img/img-banner.b0af097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-banner.png
// module id = GrOr
// module chunks = 1